import { isObject, isArray, isNumber, isString } from 'utils/typeUtils';

/**
 * メニューに紐づく顧客
 */
export type MenuCustomer = {
  /** 顧客ID */
  customerId: number;
  /** 顧客名 */
  customerName: string;
  /** 顧客詳細 */
  customerDetail: string;
  /** 顧客環境 */
  environment: string;
  /** チャンネル */
  channel: string;
};

/**
 * メニューに紐づく顧客の型ガード
 */
export const isMenuCustomer = (arg: unknown): arg is MenuCustomer => {
  const a = arg as MenuCustomer;

  return (
    isObject(a) &&
    isNumber(a.customerId) &&
    isString(a.customerName) &&
    isString(a.customerDetail) &&
    isString(a.environment) &&
    isString(a.channel)
  );
};

/**
 * メニューに紐づく顧客の配列の型ガード
 */
export const isMenuCustomers = (arg: unknown): arg is MenuCustomer[] => {
  const a = arg as MenuCustomer[];

  return isObject(a) && isArray<MenuCustomer>(a, isMenuCustomer);
};
